export default "__VITE_ASSET__CI2rG9fk__"